@if (config) {
  @if (compact) {
    <button
      type="button"
      class="app-right-panel__scrim"
      [class.is-visible]="open"
      aria-label="Close inspector"
      (click)="closeCompactPanel()"
    ></button>
  }

  <aside
    class="app-right-panel"
    [class.is-compact]="compact"
    [class.is-open]="open"
    [style.width]="compact ? null : (open ? desktopWidthStyle : '0px')"
  >
    <button
      type="button"
      class="app-right-panel__edge-toggle"
      [class.is-open]="open"
      [class.is-compact-open]="compact && open"
      [class.is-compact-closed]="compact && !open"
      [attr.aria-label]="open ? 'Hide inspector' : 'Show inspector'"
      [title]="open ? 'Hide inspector' : 'Show inspector'"
      (click)="requestToggle()"
    >
      <ion-icon [name]="toggleIcon"></ion-icon>
    </button>

    @if (!compact && open) {
      <button
        type="button"
        class="app-right-panel__resize-handle"
        aria-label="Resize inspector"
        title="Resize inspector"
        (pointerdown)="startResize($event)"
      ></button>
    }

    <div class="app-right-panel__panel" [class.is-open]="open">
      @if (config.kind === 'component-builder-inspector') {
        <app-component-builder-inspector></app-component-builder-inspector>
      } @else if (config.kind === 'website-builder-inspector') {
        <app-website-builder-inspector></app-website-builder-inspector>
      } @else {
        <div class="app-right-panel__card">
          <h2 class="app-right-panel__title mb-0 bw-title-with-info">
            {{ config.title }}
            <app-info-tooltip compact placement="left" [text]="config.description || 'Use this inspector to configure the selected workspace.'"></app-info-tooltip>
          </h2>
        </div>

        @if (config.sections?.length) {
          <div class="app-right-panel__stack">
            @for (section of config.sections; track section.title) {
              <section class="app-right-panel__card">
                <h3 class="app-right-panel__section-title mb-2 bw-title-with-info">
                  {{ section.title }}
                  @if (section.description) {
                    <app-info-tooltip compact placement="left" [text]="section.description"></app-info-tooltip>
                  }
                </h3>
                @if (section.items?.length) {
                  <ul class="app-right-panel__list mb-0">
                    @for (item of section.items; track item) {
                      <li>{{ item }}</li>
                    }
                  </ul>
                }
              </section>
            }
          </div>
        }
      }
    </div>
  </aside>
}
